import { useEffect, useState } from "react";
import { FlightUtils } from "../common/FlightUtils";
import { useGeolocation } from "../hooks/useGeolocation";
import { useStoreFly } from "../store";
import { GET } from "../utils/api";
import {
  AIRLINES_ENDPOINT,
  GET_LIST_COUNTRY,
  ITRAVEL_KEY_API,
  LIST_COUNTRIES,
  MAIN_LAMBDA,
  TOP_LOCATIONS,
} from "../utils/constants";
import { DrawerComponent } from "./common/Drawer";
import {
  Divider,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { authenticateTourVisio } from "../utils/Hote";
import axios from "axios";
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { format } from 'date-fns';
import React from "react";

const flightUtil = new FlightUtils();

const Header = ({ translation, translationContext }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  useGeolocation();
  
  // Add CSS override for mobile logo
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @media only screen and (max-width: 767px) {
        .custom-logo-override {
        }
        .navbar-brand {
          margin-top: -30px !important;
          margin-bottom: 0px !important;
        }
        .navbar-toggler {
          margin-top: -40px !important;
          margin-right: 15px !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  const setCitiesImageUrl = useStoreFly((state) => state.setCitiesImageUrl);
  const setTopLocationsForView = useStoreFly(
    (state) => state.setTopLocationsForView
  );
  const geolocation = useStoreFly((state) => state.geolocation);
  const setAirlines = useStoreFly((state) => state.setAirlines);
  const getAirlines = useStoreFly((state) => state.airlines);
  const setTopLocations = useStoreFly((state) => state.setTopLocations);
  const [topLocationList, setTopLocationList] = useState([]);
  const [popularFlightsLoading, setPopularFlightsLoading] = useState(false);
  const topLocations = useStoreFly((state) => state.topLocations);
  const topFlightsHome = useStoreFly((state) => state.topFlightsHome);
  const setTopFlightsHome = useStoreFly((state) => state.setTopFlightsHome);
  const returnOrOneWayTopLocations = useStoreFly(
    (state) => state.returnOrOneWayTopLocations
  );
  const topLocationsPassengers = useStoreFly(
    (state) => state.topLocationsPassengers
  );

  const isMobile = window.innerWidth < 801;
  const [selectLanguage, setSelectLanguage] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    translationContext?.i18n?.language || "en"
  );

  const [openMenu, setOpenMenu] = useState(false);

  const [dialogState, setDialogState] = useState(false);
  const [orderStatus, setOrderStatus] = useState('');
  const [reservationData, setReservationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getReservationDetails = async (reservationNumber) => {
    try {
      const token = await authenticateTourVisio();
      const response = await axios.post(
        "http://service.stage.paximum.com/api/bookingservice/getreservationdetail",
        { reservationNumber },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.header?.success) {
        return response.data.body;
      }
      throw new Error("Could not fetch reservation details");
    } catch (error) {
      console.error("Error fetching reservation:", error);
      throw error;
    }
  };

  const commitTransaction = async (transactionId) => {
    try {
      const token = await authenticateTourVisio();
      const response = await axios.post(
        "http://service.stage.paximum.com/api/bookingservice/committransaction",
        { transactionId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.header?.success) {
        return response.data.body;
      }
      throw new Error("Could not commit transaction");
    } catch (error) {
      console.error("Error committing transaction:", error);
      throw error;
    }
  };

  const downloadTicket = async (reservationData) => {
    try {
      // Krijo një PDF të ri
      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([595.28, 841.89]); // A4 size
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      // Vendos dimensionet e faqes
      const { width, height } = page.getSize();
      const fontSize = 12;
      let yOffset = height - 50;

      // Titulli
      page.drawText('Hotel Reservation Voucher', {
        x: 50,
        y: yOffset,
        size: 24,
        font: helveticaBold,
        color: rgb(0, 0.21, 0.39) // #003663 në RGB
      });
      yOffset -= 40;

      // Detajet e rezervimit
      const drawSection = (title, content) => {
        page.drawText(title + ':', {
          x: 50,
          y: yOffset,
          size: fontSize,
          font: helveticaBold,
          color: rgb(0, 0.21, 0.39)
        });
        yOffset -= 20;
        page.drawText(content?.toString() || 'N/A', {
          x: 50,
          y: yOffset,
          size: fontSize,
          font: helveticaFont
        });
        yOffset -= 30;
      };

      // Shto informacionin e hotelit
      if (reservationData.services && reservationData.services[0]) {
        const hotelService = reservationData.services[0];
        drawSection('Hotel Name', hotelService.name);
        drawSection('Hotel Address', hotelService.serviceDetails?.hotelDetail?.address?.addressLines?.join(', ') || 'N/A');
        drawSection('Hotel Phone', hotelService.serviceDetails?.hotelDetail?.phoneNumber || 'N/A');
        drawSection('Room Type', hotelService.serviceDetails?.room || 'N/A');
        drawSection('Board Type', hotelService.serviceDetails?.board || 'N/A');
      }

      // Shto informacionin e rezervimit
      drawSection('Reservation Number', reservationData.reservationInfo?.bookingNumber || 'N/A');
      
      // Formatimi i datave
      const checkIn = reservationData.services?.[0]?.beginDate ? 
        format(new Date(reservationData.services[0].beginDate), 'dd/MM/yyyy') : 'N/A';
      const checkOut = reservationData.services?.[0]?.endDate ? 
        format(new Date(reservationData.services[0].endDate), 'dd/MM/yyyy') : 'N/A';
      
      drawSection('Check-in', checkIn);
      drawSection('Check-out', checkOut);

      // Shto informacionin e udhëtarëve
      if (reservationData.travellers && reservationData.travellers.length > 0) {
        page.drawText('Travellers:', {
          x: 50,
          y: yOffset,
          size: fontSize,
          font: helveticaBold,
          color: rgb(0, 0.21, 0.39)
        });
        yOffset -= 20;

        reservationData.travellers.forEach((traveller, index) => {
          const travellerInfo = `${index + 1}. ${traveller.title === 1 ? 'Mr.' : 'Ms.'} ${traveller.name} ${traveller.surname}`;
          page.drawText(travellerInfo, {
            x: 70,
            y: yOffset,
            size: fontSize,
            font: helveticaFont
          });
          yOffset -= 20;
        });
        yOffset -= 10;
      }

      // Shto çmimin total
      if (reservationData.reservationInfo?.totalPrice) {
        drawSection('Total Price', 
          `${reservationData.reservationInfo.totalPrice.amount} ${reservationData.reservationInfo.totalPrice.currency}`);
      }

      // Shto informacionin e pagesës
      if (reservationData.paymentDetail?.paymentPlan) {
        const payment = reservationData.paymentDetail.paymentPlan[0];
        drawSection('Payment Due Date', 
          format(new Date(payment.dueDate), 'dd/MM/yyyy'));
        drawSection('Payment Amount', 
          `${payment.price.amount} ${payment.price.currency}`);
      }

      // Shto politikat e anulimit
      if (reservationData.services?.[0]?.cancellationPolicies) {
        const cancellation = reservationData.services[0].cancellationPolicies[0];
        drawSection('Cancellation Due Date', 
          format(new Date(cancellation.dueDate), 'dd/MM/yyyy HH:mm'));
        drawSection('Cancellation Fee', 
          `${cancellation.price.amount} ${cancellation.price.currency}`);
      }

      // Shto footer me informacionin e kontaktit
      const footerText = 'For assistance, please contact: +383 49 25 30 35';
      page.drawText(footerText, {
        x: 50,
        y: 50,
        size: 10,
        font: helveticaFont,
        color: rgb(0.5, 0.5, 0.5)
      });

      // Gjenero PDF-në
      const pdfBytes = await pdfDoc.save();
      
      // Shkarko PDF-në
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `reservation-${reservationData.reservationInfo?.bookingNumber || 'ticket'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating PDF ticket:", error);
      throw error;
    }
  };

  const checkReservationStatus = async (reservationNumber) => {
    try {
      const token = await authenticateTourVisio();
      const response = await axios.post(
        "http://service.stage.paximum.com/api/bookingservice/getreservationdetail",
        { reservationNumber },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.header?.success) {
        setReservationData(response.data.body);
        setOrderStatus('Confirmed');
        // Gjenero PDF-në me të dhënat e rezervimit
        await downloadTicket(response.data.body);
      } else {
        setOrderStatus('Not Found');
      }
    } catch (error) {
      console.error("Error checking reservation:", error);
      setOrderStatus('Error');
    }
  };

  useEffect(() => {
    const carriers = async () => {
      const response = await GET(AIRLINES_ENDPOINT, {});
      if (response) setAirlines(response);
    };
    if (!getAirlines || !getAirlines.length) {
      carriers();
    }
  }, [setAirlines, getAirlines]);

  useEffect(() => {
    const locations = async () => {
      const response = await GET(
        GET_LIST_COUNTRY(geolocation?.city || "Republic of Kosovo")
      );
      // const locations = await GET(
      //   TOP_LOCATIONS(response?.[0]?.cca2 || "XK"),
      //   {},
      //   ITRAVEL_KEY_API
      // ); 
      // setTopLocations(locations);
      // setTopLocationList(locations);
    };

    if (geolocation?.city) {
      setPopularFlightsLoading(true);
      locations();
    }
  }, [geolocation, geolocation?.city, setTopLocations]);

  useEffect(() => {
    const { tab } = topFlightsHome;

    const multiCityFlights = async () => {
      await flightUtil.setPopularFlights(
        topLocationList,
        geolocation,
        setCitiesImageUrl,
        setTopLocationsForView,
        tab,
        setTopFlightsHome,
        returnOrOneWayTopLocations,
        topLocationsPassengers
      );
      setPopularFlightsLoading(false);
    };



    if (
      topLocationList?.locations?.length &&
      geolocation?.city &&
      topFlightsHome.loading
    ) {
      multiCityFlights();
    }
  }, [
    geolocation,
    geolocation?.city,
    popularFlightsLoading,
    returnOrOneWayTopLocations,
    setCitiesImageUrl,
    setTopFlightsHome,
    setTopLocationsForView,
    topFlightsHome,
    topLocationList,
    topLocationsPassengers,
  ]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const transactionId = params.get('transactionId') || params.get('transaction_id');
    const resNumber = params.get('reservationNumber');
    
    // Only process transactions for flight pages, not hotel pages
    const isHotelPage = location.pathname.includes('/hotels/');
    if (isHotelPage) {
      return;
    }

    const finalizeBooking = async () => {
      if (!transactionId && !resNumber) return;
      
      setLoading(true);
      setError(null);
      
      try {
        let resNum = resNumber;
        
        // Nëse nuk kemi reservationNumber në URL, përdorim commit
        if (!resNum && transactionId) {
          const result = await commitTransaction(transactionId);
          if (!result?.reservationNumber) throw new Error("Reservation could not be confirmed");
          resNum = result.reservationNumber;
        }

        if (resNum) {
          // Merr detajet e rezervimit
          const details = await getReservationDetails(resNum);
          if (details) {
            setReservationData(details);
            // Shkarko biletën automatikisht
            await downloadTicket(details);
          }
        }

      } catch (err) {
        console.error("❌ Finalizing booking failed:", err);
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    finalizeBooking();
  }, [location.search]);

  const handleLanguageChange = (lang) => {
    try {
      setCurrentLang(lang);
      if (translationContext?.i18n?.changeLanguage) {
        translationContext.i18n.changeLanguage(lang);
      } else {
        // If i18n is not available, we can still update the UI language
        // and reload the page to get fresh translations
        localStorage.setItem('i18nextLng', lang);
      }
      setSelectLanguage(false);
      window.location.reload();
    } catch (error) {
      console.error('Error changing language:', error);
      // Still update the UI language even if there's an error
      setCurrentLang(lang);
      localStorage.setItem('i18nextLng', lang);
      setSelectLanguage(false);
      window.location.reload();
    }
  };

  return (
    <section className="header" style={{ marginBottom: "100px" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 topbar text-right col-md-12 col-12">
            <a className="tel" href="tel:38349253035" style={{ textDecoration: 'none' }}>
              +383 49 25 30 35
            </a>
            {!isMobile && (
              <a className="m-0">
                <span
                  onClick={() => {
                    setDialogState(true);
                    // navigate("/");
                  }}
                  className="pointer ml-5 select"
                  style={{
                    borderRadius: "11px",
                    color: "#003663",
                    fontWeight: "bolder",
                    margin: 0
                  }}
                >
                  {/* <i className="fa light  fa-user" style={{ color: "white", fontSize: 20 }} /> */}
                  <img height={25} width={25} src={require("../assets/img/profileWhite.png")} />
                </span>
              </a>
            )}

            {!isMobile && (
              <div className="dropdown country">

                <button
                  className="btn btn-primary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="true"
                  onClick={() => setSelectLanguage(!selectLanguage)}
                >
                  {(() => {
                    const flagSrc = currentLang === 'al' ? require("../assets/img/al-64.png") :
                                    (currentLang === 'de' ? require("../assets/img/germany.png") : require("../assets/img/en-64.png"));
                    const label = currentLang === 'al' ? 'SQ' : currentLang === 'de' ? 'DE' : 'EN';
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        {label}
                        <img src={flagSrc} alt={label.toLowerCase()} width={32} height={32} />
                      </div>
                    );
                  })()}
                  <img src={require("../assets/img/down-arrow.png")} alt="Language dropdown arrow" />
                </button>
                <div
                  className={`dropdown-menu ${selectLanguage && "show"}`}
                  style={{
                    left: "-50px",
                  }}
                >
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("al")}
                  >
                    <img
                      src={require("../assets/img/al-64.png")}
                      width={32}
                      height={32}
                      alt="en"
                    />{" "}
                    Shqip
                  </span>
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("en")}
                  >
                    <img
                      src={require("../assets/img/en-64.png")}
                      width={32}
                      height={32}
                      alt="en"
                    />{" "}
                    English
                  </span>
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("de")}
                  >
                    <img
                      src={require("../assets/img/germany.png")}
                      width={32}
                      height={32}
                      alt="de"
                    />{" "}
                    Deutsch
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">

          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              position: 'relative', 
              zIndex: 10,
              marginTop: window.innerWidth <= 768 ? '-30px' : '-20px',
              marginBottom: window.innerWidth <= 768 ? '0px' : '20px',
              marginLeft: window.innerWidth <= 768 ? '40px' : '15px'
            }}>
            <img 
              src={require("../assets/img/FluturolireLogoWhite.png")} 
              alt="Fluturolire Logo" 
              className="custom-logo-override"
              style={{
                height: window.innerWidth <= 768 ? '35px' : '56px',
                width: window.innerWidth <= 768 ? '145px' : '231px',
                maxWidth: '90vw',
                objectFit: 'contain',
                maxHeight: window.innerWidth <= 768 ? 'unset' : 'none',
                minHeight: window.innerWidth <= 768 ? '140px' : '160px'
              }}
            />
            </a>
            <button
              className={`navbar-toggler menu-icon ${openMenu ? "active" : ""}`}
              type="button"
              // data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => {
                setOpenMenu(!openMenu);
              }}
            >
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
            </button>
          </nav>
        </div>

      </div>


      <Dialog
        onClose={() => { }}
        // aria-labelledby="customized-dialog-title"
        open={dialogState}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "5px"
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span style={{
            color: "#003663",
            fontWeight: "bold"
          }} className="d-inline-block price-text w-100">{translation("search_booking_id")}</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            setDialogState(false);
            setOrderStatus('');
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {/* <Illustration name="Time" size="small" /> */}
          <h6 className="mt-4" style={{
            color: "#003663"
          }}>{translation("search_dialog_content")}</h6>

          <input type="text" className="form-control" required="" id="orderId" placeholder="" name="orderId" />
          <Button
            autoFocus
            onClick={async () => {
              const bookingId = document.getElementById('orderId').value;
              if (bookingId) {
                await checkReservationStatus(bookingId);
              }
            }}
            className="default-yellow-btn mt-3 select"
            style={{
              borderRadius: "11px",
              color: "#003663",
              background: "#fbd316",
              marginRight: "10px",
              marginBottom: "10px",
              fontWeight: "bolder"
            }}
          >
            {translation("search")}
          </Button>
          {orderStatus && (
            <h6 className="mt-4" style={{
              color: "#003663"
            }}>
              {orderStatus === 'Confirmed' ? 'Reservation found and PDF generated!' : 
               orderStatus === 'Not Found' ? 'Reservation not found.' : 
               'Error checking reservation.'}
            </h6>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setDialogState(false);
              setOrderStatus('');
            }}
            className="default-yellow-btn mt-3 select"
            style={{
              borderRadius: "11px",
              color: "#003663",
              background: "#fbd316",
              marginRight: "10px",
              marginBottom: "10px",
              fontWeight: "bolder"
            }}
          >
            {translation("close")}
          </Button>
        </DialogActions>
      </Dialog>

      <DrawerComponent
        open={openMenu}
        setOpen={setOpenMenu}
        headerText={translation("menu")}
        anchor="right"
      >
        <Paper>
          <MenuList>
            <MenuItem>
              <ListItemText style={{ textDecoration: 'none' }}>{translation("language")}</ListItemText>
              <div className="dropdown country">
                <button
                  className="btn "
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="true"
                  onClick={() => setSelectLanguage(!selectLanguage)}
                >
                  {(() => {
                    const flagSrc = currentLang === 'al' ? require("../assets/img/al-64.png") :
                                    (currentLang === 'de' ? require("../assets/img/germany.png") : require("../assets/img/en-64.png"));
                    const label = currentLang === 'al' ? 'SQ' : currentLang === 'de' ? 'DE' : 'EN';
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        {label}
                        <img src={flagSrc} alt={label.toLowerCase()} width={32} height={32} />
                      </div>
                    );
                  })()}
                  <img src={require("../assets/img/down-arrow.png")} alt="Mobile menu dropdown arrow" />
                </button>
                <div
                  className={`dropdown-menu ${selectLanguage && "show"}`}
                  style={{
                    left: "-50px",
                  }}
                >
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("al")}
                  >
                    <img
                      src={require("../assets/img/al-64.png")}
                      width={32}
                      height={32}
                      alt="en"
                    />{" "}
                    Shqip
                  </span>
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("en")}
                  >
                    <img
                      src={require("../assets/img/en-64.png")}
                      width={32}
                      height={32}
                      alt="en"
                    />{" "}
                    English
                  </span>
                  <span
                    className="dropdown-item"
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      paddingLeft: "10px",
                    }}
                    onClick={() => handleLanguageChange("de")}
                  >
                    <img
                      src={require("../assets/img/germany.png")}
                      width={32}
                      height={32}
                      alt="de"
                    />{" "}
                    Deutsch
                  </span>
                </div>
              </div>
            </MenuItem>
            <Divider />
            <MenuItem>
              <a 
                style={{
                  textDecoration: 'none',
                  color:
                    pathname === "/about-us"
                      ? "#005dba"
                      : "rgba(0, 0, 0, 0.87)",
                }}
              >
                <ListItemText 
                style={{ textDecoration: 'none' }}
                onClick={() => {
                  setDialogState(true);
                  // navigate("/");
                }}
                >
                  <span onClick={() => {
                      setDialogState(true);
                      // navigate("/");
                    }}>
                  {translation("search_booking_id")}
                  </span>
                  <span
                    onClick={() => {
                      setDialogState(true);
                      // navigate("/");
                    }}
                    className="pointer ml-5 select"
                    style={{
                      borderRadius: "11px",
                      color: "#003663",
                      fontWeight: "bolder",
                      margin: 0
                    }}
                  >
                    {/* <i className="fa primary  fa-user" style={{ color: "black", fontSize: 20 }} /> */}
                    <img height={35} width={35} src={require("../assets/img/profile.png")} />
                  </span>
                </ListItemText>
              </a>
            </MenuItem>
            <Divider />
            <MenuItem>
              <a
                href={currentLang === "en-US" || currentLang === "en" ? '/about-us' : currentLang === "al" ? '/rreth-nesh' : '/about-us-de'}
                style={{
                  textDecoration: 'none',
                  color:
                    pathname === "/about-us"
                      ? "#005dba"
                      : "rgba(0, 0, 0, 0.87)",
                }}
              >
                <ListItemText style={{ textDecoration: 'none',}}>{translation("about_us")}</ListItemText>
              </a>
            </MenuItem>
            <Divider />

            <MenuItem>
              <a
                href="/how-to"
                style={{
                  textDecoration: 'none',
                  color:
                    pathname === "/visit-dubai"
                      ? "#005dba"
                      : "rgba(0, 0, 0, 0.87)",
                }}
              >
                <ListItemText>{translation("howto")}</ListItemText>
              </a>
            </MenuItem>
            <Divider />
            <Divider />
            <MenuItem>
              <a
                href="/contact-us"
                style={{
                  textDecoration: 'none',
                  color:
                    pathname === "/contact-us"
                      ? "#005dba"
                      : "rgba(0, 0, 0, 0.87)",
                }}
              >
                <ListItemText>{translation("contact_us")}</ListItemText>
              </a>
            </MenuItem>
            <Divider />
          </MenuList>
        </Paper>
      </DrawerComponent>
    </section>
  );
};

export default Header;
